import { React } from '@digsup/core-ui';
import { Icon } from '@digsup/components-icon';
import { Image } from '@digsup/components-image';

import { FeaturesItem } from './FeaturesItem';
import alertsImg from './assets/alerts.png';
import alerts2xImg from './assets/alerts@2x.png';
import alerts3xImg from './assets/alerts@3x.png';
import alertsMobileImg from './assets/alerts-mobile.png';
import alertsMobile2xImg from './assets/alerts-mobile@2x.png';
import alertsMobile3xImg from './assets/alerts-mobile@3x.png';

export const FeatureAlerts = () => (
  <FeaturesItem
    title="First to know"
    description="Alerts for when something changes about a property you love, or when we think it's about to go on the market."
    icon={
      <Icon
        name="bell"
        size="xlarge"
        shape="round"
        fill="white"
        shapeColor="unicorn"
        className="l-homepage-features__alerts-icon"
      />
    }
    media={
      <div className="l-homepage-features__alerts-media">
        <div className="l-homepage-features__alerts-media-img">
          <Image
            src={alertsImg}
            srcset={`
              ${alertsMobileImg} 404w,
              ${alertsImg} 552w,
              ${alertsMobile2xImg} 808w,
              ${alerts2xImg} 1104w,
              ${alertsMobile3xImg} 1212w,
              ${alerts3xImg} 1656w
            `}
            sizes="(max-width: 999px) 404px, 552px"
            placeholderImage=""
            alt="Property alerts"
          />
        </div>
      </div>
    }
  />
);
